// src/app/guards/consent.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UsersService } from '../services/users.service';

/**
 * Protege las vistas autenticadas: si el usuario no ha dado su consentimiento
 * (`consent !== true`) lo redirige a la pantalla intermedia `/consent`.
 * Se aplica siempre después del AuthGuard, por eso si no está autenticado deja pasar
 * (será el AuthGuard quien lo mande a /login).
 */
export const ConsentGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const usersService = inject(UsersService);
  const router = inject(Router);

  await authService.waitUntilReady();

  if (!authService.isAuthenticated()) {
    return true;
  }

  try {
    const user = await usersService.getMe();
    if (user?.consent === true) {
      return true;
    }
    return router.createUrlTree(['/consent']);
  } catch {
    return router.createUrlTree(['/login']);
  }
};

/**
 * Protege SÓLO la ruta `/consent`: evita el bucle de redirección y mantiene fuera a
 * quien ya ha consentido (lo devuelve a /tabs).
 */
export const ConsentPendingGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const usersService = inject(UsersService);
  const router = inject(Router);

  await authService.waitUntilReady();

  try {
    const user = await usersService.getMe();
    if (user?.consent === true) {
      return router.createUrlTree(['/tabs']);
    }
    return true;
  } catch {
    return router.createUrlTree(['/login']);
  }
};
